<template>
  <div id="app">
    <el-alert
        light
        center
        show-icon
        v-show="!is_Empty($store.state.sale_info)"
        title="当前处于代客下单模式"
        @close="onClose"
        type="success">
    </el-alert>
    <keep-alive v-if="$route.meta.keepalive">
      <router-view/>
    </keep-alive>
    <router-view v-else/>
  </div>
</template>

<script>
export default {
  name: "App",
  methods: {

    onClose() {
      let _this = this;
      let sale_info = JSON.parse(JSON.stringify(this.$store.state.sale_info))

      this.$store.commit("SET", {
        key: "recommendGoodsList",
        value: []
      })
      this.$store.commit('setCurrentCompanyId', '');
      _this.$store.commit('setMemberInfo', sale_info)
      _this.$store.commit('setUserPermission', this.$store.state.sale_permission_ids)
      _this.$store.commit('setSaleInfo', null)
      _this.$store.commit('setSalePermission_ids', null)
      _this.$store.commit('editInstance', null)
      _this.go('/home/index')
      this.$message({
        type: 'success',
        message: '已退出!'
      });
    },
  },
  mounted() {
    let _this = this;
    // _this.$store.commit('setMemberInfo', null)
    // _this.$store.commit('setUserPermission', null)
    // _this.$store.commit('setSaleInfo', null)
    // _this.$store.commit('setSalePermission_ids', null)
    // _this.$store.commit('editInstance', null)
    // this.init();
  },
};
</script>

<style lang="scss">
body {
  background-color: #f4f4f4;
}

::-webkit-scrollbar { /* 滚动条整体样式 */
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}

::-webkit-scrollbar-thumb { /* 滚动条里面小方块 */
  border-radius: 10px;
  /*/ / -webkit-box-shadow: inset 0 0 5 px #FF5E00;*/
  background: rgba(0, 0, 0, 0.7);
}

::-webkit-scrollbar-track { /* 滚动条里面轨道 */
  /*// -webkit-box-shadow: inset 0 0 5 px #FFD6B1;*/
  /*// border-radius: 5 px;*/
  background-color: transparent;
}

/* 需要滚动的地方加上这个class */
.auto-scroll ::-webkit-scrollbar { /* 组件内滚动条不显示 */
  display: none;
}

.auto-scroll:hover ::-webkit-scrollbar { /* 悬停时滚动条才显示 */
  display: block;
}

#app {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  background-color: #f4f4f4;

  &::-webkit-scrollbar {
    /// / display:none;
    width: 0;
  }

}
</style>



// WEBPACK FOOTER //
// src/App.vue